import { call, put, select } from "redux-saga/effects";
import { actions as catalogActions } from "@/reducers/catalogue";
import { getCatalogueProductOfferingNormalizer } from "@/sagas/normalizers/catalogueNormalizer";
// import getProductOffering from "@gcloud-npm/adabyron.client.catalogo.oferta";@/adabyron/telcol
import getProductOffering from "@/adabyron/telcol/catalogo/oferta";
// import getProductOfferingAttachments from "@gcloud-npm/adabyron.client.catalogo.documentos";
import getProductOfferingAttachments from "@/adabyron/telcol/catalogo/documentos";
// import { isR2RAvailableToPurchase as isR2RAvailableToPurchasePromise } from "@gcloud-npm/adabyron.client.catalogo.renttorent.disponibilidad";
import { isR2RAvailableToPurchase as isR2RAvailableToPurchasePromise } from "@/adabyron/telcol/catalogo/renttorent/disponibilidad";
import { handleSagaError } from "@/sagas/index";

import {
  idFront,
  TITULAR,
  link2ChooseSmartphoneUrl,
  link2ChooseSmartphoneUrlPikolin,
  nookInfoExchangeIds,
} from "@/constants/constants";
import { mobileRent2RentItem2Notification } from "@/sagas/normalizers/notificationsNormalizer";
import { checkMocks, sendMessageHeader } from "@/utils/commonUtils";
const contextStore = (state) => state.main.context;

const catalogueProductOfferingStore = (state) =>
  state.catalogue.catalogueProductOffering;
const catalogueProductOfferingAttachmentsStore = (state) =>
  state.catalogue.catalogueProductOfferingAttachments;
const hiredProductsStore = (state) => state.product.hiredProducts;
const pikolinStore = (state) => state.user.pikolin;
const scopeStore = (state) => state.user.scope;

export function* getCatalogueProductOffering({ idPO, handlingCode = 0 }) {
  try {
    const catalogueProductOfferingData = yield select(
      catalogueProductOfferingStore
    );

    if (!catalogueProductOfferingData[idPO]) {
      const context = yield select(contextStore);
      const data = { idPO: idPO };
      const response = yield call(getProductOffering, { data, context });
      const hiredProductsData = yield select(hiredProductsStore);
      const pikolin = yield select(pikolinStore);
      const productOfferingNormalized = getCatalogueProductOfferingNormalizer(
        hiredProductsData,
        response.datos,
        pikolin
      );
      yield put(
        catalogActions.successGetCatalogueProductOffering(
          productOfferingNormalized
        )
      );
    } else {
      yield put(catalogActions.successGetCatalogueProductOffering(null));
    }
  } catch (error) {
    const reducerFailureAction =
      catalogActions.failureGetCatalogueProductOffering();
    yield handleSagaError(
      "getCatalogueProductOffering",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
  }
}

export function* getCatalogueProductOfferingAttachments({
  idPO,
  handlingCode = 0,
}) {
  try {
    const catalogueProductOfferingAttachmentsData = yield select(
      catalogueProductOfferingAttachmentsStore
    );

    if (!catalogueProductOfferingAttachmentsData[idPO]) {
      const context = yield select(contextStore);
      const data = { idPO: idPO };
      const response = yield call(getProductOfferingAttachments, {
        data,
        context,
      });
      
      yield put(
        catalogActions.successGetCatalogueProductOfferingAttachments(
          response.datos
        )
      );
    } else {
      yield put(
        catalogActions.successGetCatalogueProductOfferingAttachments(null)
      );
    }
  } catch (error) {
    const reducerFailureAction =
      catalogActions.failureGetCatalogueProductOfferingAttachments();
    yield handleSagaError(
      "getCatalogueProductOfferingAttachments",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
  }
}

export function* isR2RAvailableToPurchase({ typeR2R, handlingCode = 0 }) {
  try {
    const MOCK_INFO = "isR2RAvailableToPurchase";
    const context = yield select(contextStore);
    const data = { type: typeR2R };

    let response = checkMocks(MOCK_INFO);
    if (response === null) {
      response = yield call(isR2RAvailableToPurchasePromise, {
        data,
        context,
        idFront,
      });
    }

    const isRent2Rent =
      response &&
      response.datos &&
      response.datos.incluido &&
      response.datos.incluido.availableForPurchase;
    const isRent2RentAdditional =
      response &&
      response.datos &&
      response.datos.adicional &&
      response.datos.adicional.availableForPurchase;
    if (isRent2Rent || isRent2RentAdditional) {
      const scope = yield select(scopeStore);
      const pikolin = yield select(pikolinStore);
      if (scope === TITULAR) {
        let link2ChooseSmartphone = link2ChooseSmartphoneUrl;
        if (pikolin) {
          link2ChooseSmartphone = link2ChooseSmartphoneUrlPikolin;
        }
        const item2ReturnNotification = {
          link: link2ChooseSmartphone,
        };
        const item2Return = mobileRent2RentItem2Notification(
          item2ReturnNotification,
          isRent2Rent,
          isRent2RentAdditional,
          pikolin
        );
        sendMessageHeader(nookInfoExchangeIds.Notifications, item2Return);
      }
    }
    yield put(catalogActions.successIsR2RAvailableToPurchase(response.datos));
  } catch (error) {
    const reducerFailureAction =
      catalogActions.failureIsR2RAvailableToPurchase(error);
    yield handleSagaError(
      "isR2RAvailableToPurchase",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
  }
}
